import { render, staticRenderFns } from "./MusicBtn.vue?vue&type=template&id=173c8f2a&scoped=true&"
import script from "./MusicBtn.vue?vue&type=script&lang=js&"
export * from "./MusicBtn.vue?vue&type=script&lang=js&"
import style0 from "./MusicBtn.vue?vue&type=style&index=0&id=173c8f2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c8f2a",
  null
  
)

export default component.exports